import React from 'react';
import type { Engagement } from '../types';
import { formatDate } from '../utils/format';

interface DeleteModalProps {
  engagement: Engagement;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteModal: React.FC<DeleteModalProps> = ({
  engagement,
  onConfirm,
  onCancel,
}) => {
  return (
    <div className="fixed inset-0 bg-black/50 dark:bg-black/70 flex items-center justify-center z-50 p-4 transition-colors duration-300">
      <div className="bg-white dark:bg-neutral-900 rounded-lg shadow-2xl max-w-md w-full transition-colors duration-300">
        <div className="p-6">
          <h2 className="text-xl font-semibold mb-4 text-taxtrail-text dark:text-taxtrail-dark-text">Delete Engagement?</h2>
          <p className="text-gray-600 dark:text-gray-400 mb-2">
            Are you sure you want to delete this engagement?
          </p>
          <p className="font-medium text-taxtrail-text dark:text-taxtrail-dark-text">{engagement.clientName}</p>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            {formatDate(engagement.taxYearEnd)} • {engagement.taxForm}
          </p>
        </div>

        <div className="p-6 border-t border-gray-200 dark:border-neutral-700 flex gap-3 justify-end">
          <button
            onClick={onCancel}
            className="px-4 py-2 border border-gray-300 dark:border-neutral-600 rounded hover:bg-gray-50 dark:hover:bg-neutral-800 transition-colors font-medium text-taxtrail-text dark:text-taxtrail-dark-text focus:outline-none focus:ring-2 focus:ring-green-600 dark:focus:ring-green-500"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 rounded font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-red-600 dark:focus:ring-red-500"
            style={{ backgroundColor: '#dc2626', color: '#ffffff' }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#b91c1c'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#dc2626'}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};
